
import { createTranslationRef, createTranslationResource } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const appTranslationRef = createTranslationRef({
    id: 'plugin.backstage-app',
    messages: {
        homePage: {
            header: {
                title: 'Welcome to ZCorp Developer Portal'
            }
        },
        rootPage: {
            sidebar: {
                searchLabel: 'Search',
                menuLabel: 'Menu',
                homeLabel: 'Home',
                catalogLabel: 'App Catalog',
                registryLabel: 'Registry',
                pluralGroupsLabel: 'My Groups',
                singularGroupLabel: 'My Group',
                apisLabel: 'APIs',
                docsLabel: 'Docs',
                createLabel: 'Create...',
                techRadarLabel: 'Tech Radar',
                settingsLabel: 'Settings',
                signOutLabel: "Sign Out"
            }
        },
        signOut: {
            signOutButton: 'Sign Out',
            dialog: {
                title: 'Confirm Sign Out',
                message: 'Are you sure you want to sign out?',
                cancel: 'Cancel',
                confirm: 'Sign Out'
            }
        },
        searchPage: {
            header: {
                title: 'Search'
            },
            searchType: {
                title: 'Result type',
                softwareCatalog: 'Software Catalog',
                documentation: 'Documentation',
            },
            searchFilter: {
                entity: 'Entity',
                kind: 'Kind',
                lifecycle: 'Lifecycle'
            }
        },
        entityPage: {
            overview: {
                title: 'Overview'
            },
            gitlab: {
                title: 'GitLab',
                viewOnGitlabLink: 'VIEW ON GITLAB'
            },
            logs: {
                title: 'LOGS',
                noLogsMessage: 'Waiting for logs...'
            },
            configuration: {
                title: 'Configuration',
            },
            deployment: {
                title: 'Deployments',
                createDeploymentDialog: {
                    title: 'CONFIRM NEW DEPLOYMENT',
                    cancelDeployment: 'CANCEL',
                    confirmDeployment: 'DEPLOY',
                },
                noDeploymentFound: 'No application deployment avaiable',
                noDeploymentFoundByEnvironment: 'No deployments found for the selected environment.',
                jobStatusTitle: 'Status: {{status}}',
                pipelineStatusTitle: 'Deployment status: {{status}}',
                newDeployment: 'RUN NEW DEPLOYMENT',
                newDeploymentSuccessMessage: 'Successfully sent application deployment request',
                newDeploymentErrorMessage: 'Error sending application deployment request',
                fields: {
                    labels: {
                        date: 'DEPLOY DATE:',
                        status: 'STATUS',
                        pipelineJobs: 'PIPELINE JOBS',
                        triggeredBy: 'TRIGGERED BY'
                    }
                }
            },
            infrastructure: {
                title: 'Infrastructure',
                noWorkloadFound: 'No workload found',
                noWorkloadDeploymentFoundByEnvironment: 'No deployment found for the selected environment.',
                noWorkloadsFoundByEnvironment: 'No workloads found for the selected environment.',
                workloadStatusMessage: 'Workload status: {{status}}',
                workloadHealthMessage: 'Workload health: {{status}}',
                workloadListTitle: 'WORKLOADS',
                newWorkload: 'DEPLOY INFRASTRUCTURE',
                newWorkloadSuccessMessage: 'Successfully sent workload deployment request',
                newWorkloadErrorMessage: 'Error sending workload deployment request',
                deployStatus: 'Last deployment status: {{status}}',
                createWorkloadDialog: {
                    title: 'CONFIRM NEW DEPLOYMENT',
                    cancelDeployment: 'CANCEL',
                    confirmDeployment: 'DEPLOY',
                },
                fields: {
                    labels: {
                        cpu: 'CPU:',
                        memory: 'MEMORY',
                        startedAt: 'STARTED AT',
                        stoppedAt: 'STOPPED AT:',
                        statusReason: 'STATUS REASON:',
                        status: 'STATUS',
                        health: 'HEALTH',
                        version: 'VERSION:',
                        workloadAddress: 'ADDRESS',
                        lastDeploymentTitle: 'LAST DEPLOYMENT',
                        lastDeploymentStatus: 'STATUS',
                        lastDeploymentDate: 'DATE: ',
                        triggeredBy: 'TRIGGERED BY'
                    }
                }
            },
            database: {
                title: 'Databases',
                connectionDialog: {
                    title: 'DATABASE CONNECTION INFORMATION',
                    description: 'To connect to this database instance, use the following configuration:',
                    javaTitle: 'Java - Spring Boot',
                    javaProperties: 'In a application.properties file',
                    javaYaml: 'In a application.yaml file',
                    othersTitle: 'Others',
                    othersDescription: 'For others languages, this are the environment variables:',
                    connectionWarning: 'THE ENVIRONMENT VARIABLES ARE ALREADY INJECTED IN THE CONTAINER',
                    closeDialog: 'CLOSE'
                },
                createDatabaseDialog: {
                    title: 'DEPLOY NEW DATABASE',
                    engine: 'ENGINE',
                    cancelDeployment: 'CANCEL',
                    confirmDeployment: 'DEPLOY',
                },
                noDatabaseFound: 'No database status avaiable',
                noDatabaseFoundByEnvironment: 'No database found for the selected environment.',
                status: 'The database status is {{status}}',
                pipelineStatus: 'Last deployment status: {{status}}',
                newDatabase: 'CREATE DATABASE',
                newDatabaseSuccessMessage: 'Successfully sent database deployment request',
                newDatabaseErrorMessage: 'Error sending database deployment request',
                openConnectionDialog: 'SHOW CONNECTION INFORMATION',
                fields: {
                    labels: {
                        engine: 'ENGINE',
                        status: 'STATUS',
                        lastDeployment: 'LAST DEPLOYMENT',
                        lastDeploymentStatus: 'STATUS:',
                        lastDeploymentDate: 'DEPLOY DATE:',
                        triggeredBy: 'TRIGGERED BY'
                    }
                }
            },
            api: {
                title: 'API'
            },
            dependencies: {
                title: 'Dependencies'
            },
            docs: {
                title: 'Docs'
            },
            definition: {
                title: 'Definition'
            },
            diagram: {
                title: 'Diagram'
            },
            environment: {
                title: 'ENVIRONMENT',
                dev: 'DEVELOPMENT',
                hlg: 'HOMOLOGATION',
                prd: 'PRODUCTION'
            }
        },
    },
});

export const appTranslations: any =  TranslationBlueprint.make({
    name: 'app-translations-pt-br',
    params: {
        resource: createTranslationResource({
            ref: appTranslationRef,
            translations: {
                'pt-BR': () => import('./app-ptbr'),
            },
        }),
    },
});